var React = require('react');

function Lock (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 5.744c.363 0 .677.128.944.384.267.256.4.565.4.928v6.688c0 .363-.133.672-.4.928a1.318 1.318 0 0 1-.944.384H4c-.363 0-.677-.128-.944-.384a1.24 1.24 0 0 1-.4-.928V7.056c0-.363.133-.672.4-.928s.581-.384.944-.384h.656V4.4c0-.608.15-1.168.448-1.68A3.324 3.324 0 0 1 6.32 1.504 3.275 3.275 0 0 1 8 1.056c.608 0 1.168.15 1.68.448.512.299.917.704 1.216 1.216.299.512.448 1.072.448 1.68v1.344H12zm-1.936 0V4.4a2 2 0 0 0-.28-1.024 2.077 2.077 0 0 0-.76-.76A2 2 0 0 0 8 2.336a2 2 0 0 0-1.024.28c-.32.187-.573.44-.76.76a2 2 0 0 0-.28 1.024v1.344h4.128zm-2.064 6c.363 0 .677-.133.944-.4.267-.267.4-.581.4-.944s-.133-.677-.4-.944a1.291 1.291 0 0 0-.944-.4c-.363 0-.677.133-.944.4-.267.267-.4.581-.4.944s.133.677.4.944c.267.267.581.4.944.4z","fill":"currentColor","fillRule":"evenodd"}));
}

Lock.defaultProps = {"viewBox":"0 0 16 16","width":"16","height":"16"};

module.exports = Lock;

Lock.default = Lock;
